// extracted by mini-css-extract-plugin
export default {"info":"InfoList_info__lyaDx","coloum":"InfoList_coloum__guJl5","icon":"InfoList_icon__imjas","title":"InfoList_title__8rjvu","txt3":"InfoList_txt3__NwvQJ"};